import React from 'react';
import { isToday } from 'date-fns';

const ALL_SLOTS = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00'];

export default function TimeSlotGrid({ selectedSlot, onSelect, slotRemaining = {}, selectedDate, onWaitlist, slots }) {
  const now = new Date();
  const slotList = slots && slots.length ? slots : ALL_SLOTS;
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
      {slotList.map((slot) => {
        const remaining = slotRemaining[slot];
        const hasData = typeof remaining === 'number';
        const isAvailable = !hasData || remaining > 0;
        const isSelected = selectedSlot === slot;

        // Disable slots that have already passed when the selected date is today
        let isPastSlot = false;
        if (selectedDate) {
          const selDate = selectedDate instanceof Date ? selectedDate : new Date(selectedDate);
          if (isToday(selDate)) {
            const slotHour = parseInt(slot.split(':')[0], 10);
            isPastSlot = slotHour <= now.getHours();
          }
        }

        if (isPastSlot) {
          return (
            <button key={slot} disabled
              className="py-2.5 text-sm font-bold bg-white/3 text-white/10 cursor-not-allowed line-through">
              {slot}
            </button>
          );
        }

        // Sold-out slot — clickable to join the waitlist
        if (!isAvailable) {
          return (
            <button
              key={slot}
              onClick={() => onWaitlist?.(slot)}
              title="Sold out — join the waitlist"
              className="py-1.5 text-sm font-bold transition-all duration-150 border border-primary/30 bg-primary/5 text-primary hover:bg-primary/10 hover:border-primary/50"
            >
              <span className="line-through opacity-70 block leading-none">{slot}</span>
              <span className="block text-[8px] tracking-widest mt-0.5">WAITLIST</span>
            </button>
          );
        }

        // Available slot — show time + remaining count
        return (
          <button
            key={slot}
            onClick={() => onSelect(slot)}
            className={`py-1.5 text-sm font-bold transition-all duration-150 ${
              isSelected
                ? 'bg-primary text-white'
                : 'bg-[#111115] text-white/50 hover:text-white border border-white/5 hover:border-white/20'
            }`}
          >
            <span className="block leading-none">{slot}</span>
            {hasData && (
              <span className={`block text-[8px] tracking-widest mt-0.5 ${isSelected ? 'text-white/60' : 'text-emerald-500/70'}`}>
                {remaining} LEFT
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}